import Nullstack from 'nullstack';
export default function IconAbacus({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-abacus",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 3v18"
  }), "   ", Nullstack.element("path", {
    d: "M19 21v-18"
  }), "   ", Nullstack.element("path", {
    d: "M5 7h14"
  }), "   ", Nullstack.element("path", {
    d: "M5 15h14"
  }), "   ", Nullstack.element("path", {
    d: "M8 13v4"
  }), "   ", Nullstack.element("path", {
    d: "M11 13v4"
  }), "   ", Nullstack.element("path", {
    d: "M16 13v4"
  }), "   ", Nullstack.element("path", {
    d: "M14 5v4"
  }), "   ", Nullstack.element("path", {
    d: "M11 5v4"
  }), "   ", Nullstack.element("path", {
    d: "M8 5v4"
  }), "   ", Nullstack.element("path", {
    d: "M3 21h18"
  }), " ");
}